import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

@doc.path('/plan_analyses/{id}/generate')
export default class PlanAnalysisGenerateModel extends MapServiceModel {
}
